import { SingleEventPrediction } from "../SingleEventPrediction";
import { StagePointsTable } from "../../Scoring/StagePointsTables";
import { Athlete } from "../../../Shared/Athlete";
import { IEventPredictionFinalistsSelectionStrategy } from "./EventPredictionFinalistsSelectionStrategy";
import { immerable } from "immer";

export class Wsm2026EventPredictionFinalistsSelectionStrategy implements IEventPredictionFinalistsSelectionStrategy {
	[immerable] = true;
	public GetFinalists(_eventPredictions: Array<SingleEventPrediction>, pointsTable: StagePointsTable): Array<Athlete> {
		return pointsTable
			.AthletesWithPoints
			.filter(x => (x.Position === 1 || x.Position === 2) && x.Points > 0)
			.map(x => x.Athlete)
			.filter((x): x is Athlete => !!x);
	}
}